module.exports = __webpack_public_path__ + "assets/felleskjopet-logo.f3c5b7af.svg";